import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { BoxButton, Description, Drawer, DrawerContent, DrawerFooter, DrawerHeader, ModalStickyBottomWrapper, Svg } from '@repo/ui';

export const IncomeNoticeModal = NiceModal.create(() => {
  const { visible, hide } = useModal();

  return (
    <Drawer open={visible}>
      <DrawerContent disableOutsideClick={true}>
        <DrawerHeader>
          <Description
            size={'medium'}
            title={'종합소득세 환급금까지\n함께 조회됐어요!'}
            description={'추가로 찾은 환급금을 놓치지 않도록\n바로 신청해보세요.'}
            graphic={<Svg src="icg_bulb_md.svg" width={80} height={80} />}
          />
        </DrawerHeader>
        <DrawerFooter>
          <ModalStickyBottomWrapper align={'vertical'}>
            <BoxButton size={'large'} className={'w-full'} variant={'filled-primary'} onClick={hide}>
              환급금 확인하기
            </BoxButton>
          </ModalStickyBottomWrapper>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
});
